<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="120px" v-loading="loading">
        <el-row :span="24">

          <el-col :span="24">
            <el-form-item prop="materialsName" label="供应商名称">
              {{ formData.materialsName || '--' }}
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="materialsDz" label="供应商地址">
              {{ formData.materialsDz || '--' }}
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="contactNumber" label="联系方式">
              {{ formData.contactNumber || '--' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload v-model="formData.fileList" disabled readonly></file-upload>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'rawMaterialSupplierDetail',

  data () {
    return {
      formData: {

        materialsName: '',
        materialsDz: '',
        contactNumber: '',
        fileList: []
      },

      loading: false

    }
  },
  created () {
    if (this.materialsId) {
      this.loadData()
    }
  },
  computed: {
    materialsId () {
      return this.$route.query.materialsId
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.rawMaterialSupplier.selectPaRawMaterialsByMaterialsId, {
          params: { materialsId: this.materialsId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
